// Task #353. The cart drawer replaces its entire inner DOM on every cart mutation
// (replaceContent_fn in the vendored theme.js), which wipes anything Nosto rendered.
// Nosto only rebuilds its placements on demand, so recommendations must be reloaded
// after each re-render.
//
// Hooked to "cart-drawer:refreshed" rather than "cart:change" deliberately: that event
// is dispatched after replaceChildren and bubbles to document, so it covers every cart
// mutation path without racing the rebuild.

type NostoApi = { loadRecommendations: () => void };
type NostoJs = (callback: (api: NostoApi) => void) => void;

const RELOAD_DELAY = 200;

let reloadTimer: ReturnType<typeof setTimeout> | null = null;

function reloadNostoRecommendations(): void {
  const nostojs = (window as unknown as { nostojs?: NostoJs }).nostojs;

  // The app embed may be disabled per market, absent on a preview theme, or blocked
  // by consent tooling. Calling nostojs() before the stub exists throws.
  if (typeof nostojs !== "function") return;

  nostojs((api) => {
    try {
      api.loadRecommendations();
    } catch (error) {
      console.error("[nosto-minicart] loadRecommendations failed", error);
    }
  });
}

// ponytail: trailing debounce, the drawer can re-render several times in quick
// succession (rapid quantity clicks). Swap for a scoped
// createRecommendationRequest().setElements([...]) once the placement ID is confirmed,
// so a cart change stops re-rendering unrelated placements on the same page.
document.addEventListener("cart-drawer:refreshed", () => {
  if (reloadTimer !== null) clearTimeout(reloadTimer);
  reloadTimer = setTimeout(reloadNostoRecommendations, RELOAD_DELAY);
});
